/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnChanges} from '@angular/core';
import * as _ from 'lodash';
import {ALL_COUNTRIES} from '../../common/directives/country-select/countries';

import {TARGETING_IMPORTS} from '../targeting-imports';

@Component({
  imports: TARGETING_IMPORTS,
  selector: 'adn-targeting-site-country-target-summary',
  template: '<span *ngFor="let siteCountry of siteCountries; let last = last">{{siteCountry.name}}<span *ngIf="!last">, </span></span>'
})
export class SiteCountrySummaryComponent implements OnChanges {
  @Input() targets: any;

  siteCountries: Array<{code: string; name: string}> = [];

  ngOnChanges(): void {
    const target = this.targets || {};
    this.siteCountries = _.map(target.countries, (countryCode) => {
      return _.find(ALL_COUNTRIES, (country) => country.code === countryCode) || {
        code: countryCode,
        name: countryCode
      };
    });
  }
}
